import {
	RESET_STATE,
	SET_CUSTOMERS,
	SET_IS_CUSTOMERS_LOADING,
	SET_ORDER_INFO,
	SET_IS_ORDER_DELETING,
	SET_IS_ORDER_INFO_LOADING,
	SET_IS_ORDER_SAVING,
	SET_IS_ADDRESSES_LOADING,
	SET_ADDRESSES,
	SET_IS_MODES_LOADING,
	SET_MODES,
	SET_PARTNERS,
	SET_IS_PARTNERS_LOADING,
	SET_PARTNER_SEARCH_VALUE,
	SET_ADDRESS_SEARCH_VALUE,
	SET_CONTACTS,
	SET_IS_CONTACTS_LOADING,
	SET_CONTACT_SEARCH_VALUE,
} from './actions';

export const initialState = {
	orderInfo: null,
	isOrderInfoLoading: false,
	isOrderDeleting: false,
	isOrderSaving: false,
	isPartnersLoading: false,
	customers: [],
	isCustomersLoading: false,
	partners: { 0: [], 1: [] },
	partnerSearchValue: { 0: '', 1: '' },
	isAddressesLoading: {},
	addresses: { 0: [], 1: [] },
	addressSearchValue: { 0: '', 1: '' },
	isContactsLoading: {},
	contacts: { 0: [], 1: [] },
	contactSearchValue: { 0: '', 1: '' },
	isModesLoading: false,
	modes: [],
};

const ordersModalReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case SET_ORDER_INFO:
			return {
				...state,
				orderInfo: payload,
			};
		case SET_IS_ORDER_INFO_LOADING:
			return {
				...state,
				isOrderInfoLoading: payload,
			};
		case SET_IS_ORDER_DELETING:
			return {
				...state,
				isOrderDeleting: payload,
			};
		case SET_IS_ORDER_SAVING:
			return {
				...state,
				isOrderSaving: payload,
			};
		case SET_CUSTOMERS:
			return {
				...state,
				customers: payload,
			};
		case SET_IS_CUSTOMERS_LOADING:
			return {
				...state,
				isCustomersLoading: payload,
			};
		case SET_PARTNERS:
			return {
				...state,
				partners: payload,
			};
		case SET_IS_PARTNERS_LOADING:
			return {
				...state,
				isPartnersLoading: payload,
			};
		case SET_PARTNER_SEARCH_VALUE:
			return {
				...state,
				partnerSearchValue: payload,
			};
		case SET_ADDRESSES:
			return {
				...state,
				addresses: payload,
			};
		case SET_IS_ADDRESSES_LOADING:
			return {
				...state,
				isAddressesLoading: payload,
			};
		case SET_ADDRESS_SEARCH_VALUE:
			return {
				...state,
				addressSearchValue: payload,
			};
		case SET_CONTACTS:
			return {
				...state,
				contacts: payload,
			};
		case SET_IS_CONTACTS_LOADING:
			return {
				...state,
				isContactsLoading: payload,
			};
		case SET_CONTACT_SEARCH_VALUE:
			return {
				...state,
				contactSearchValue: payload,
			};
		case SET_IS_MODES_LOADING:
			return {
				...state,
				isModesLoading: payload,
			};
		case SET_MODES:
			return {
				...state,
				modes: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default ordersModalReducer;
